import { FormAtylBase } from '../../form-atyl-base'

export class AtylSubSection extends FormAtylBase<string> {
	controlType = 'subSection'
	type: string

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || ''
	}
}
